import {
  EmptyBlock,
  InlineList,
  InlineListItem,
} from '@orobix/orobix-fe-components'
import { useTranslation } from 'react-i18next'
import { v4 as uuidv4 } from 'uuid'

import ObservationItem from '../ObservationItem/ObservationItem'
import {
  MenuContextualItems,
  OnActionCallback,
  TagDecorator,
} from '../ObservationItem/types'
import { Observation } from './types'

interface ObservationsListProps {
  children?: (observation: Observation) => React.ReactNode
  observations?: Observation[]
  onItemClick?: OnActionCallback
  tagDecorator?: TagDecorator
  menuContextualItems?: MenuContextualItems
  emptyMessage?: string | React.ReactElement
  currentObservationId?: number
}

const ObservationsList = ({
  children,
  observations,
  onItemClick,
  tagDecorator,
  menuContextualItems,
  emptyMessage,
  currentObservationId,
}: ObservationsListProps) => {
  const { t } = useTranslation()

  return observations ? (
    <>
      <InlineList>
        {observations.map((observation) => (
          <InlineListItem key={uuidv4()}>
            {children ? (
              children(observation)
            ) : (
              <ObservationItem
                observation={observation}
                onClick={onItemClick}
                tagDecorator={tagDecorator}
                menuContextualItems={menuContextualItems}
                isActive={observation.id === currentObservationId}
              />
            )}
          </InlineListItem>
        ))}
      </InlineList>
      {observations.length === 0 && (
        <>
          {typeof emptyMessage === 'string' && (
            <EmptyBlock message={emptyMessage} />
          )}

          {typeof emptyMessage !== 'string' &&
            typeof emptyMessage !== 'undefined' &&
            emptyMessage}

          {!emptyMessage && (
            <EmptyBlock
              message={t("There's nothing here. Try uploading a new image.")}
            />
          )}
        </>
      )}
    </>
  ) : null
}

export default ObservationsList
